// extracted by mini-css-extract-plugin
export default {"container":"Spinner_container__e637G","spinner":"Spinner_spinner__Br+0s","spin":"Spinner_spin__gRous","hideLoadingTextFromScreen":"Spinner_hideLoadingTextFromScreen__XkrvE"};